import { render, staticRenderFns } from "./chartGenerator.vue?vue&type=template&id=f808dd12&scoped=true&lang=pug&"
import script from "./chartGenerator.vue?vue&type=script&setup=true&lang=js&"
export * from "./chartGenerator.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./chartGenerator.vue?vue&type=style&index=0&id=f808dd12&prod&lang=scss&scoped=true&"
import style1 from "./chartGenerator.vue?vue&type=style&index=1&id=f808dd12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f808dd12",
  null
  
)

export default component.exports